// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2KlW0","dragIcon":"Choice_dragIcon__fV1nE","left":"Choice_left__3r9fT","input":"Choice_input__2DuwI"};